<section class="main-layout h-full spinner">
    <mat-spinner></mat-spinner>
</section>